// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"306e53e3","255":"27654b12","519":"0c818c1a"}[chunkId] + ".chunk.js";
};